import { render, staticRenderFns } from "./NotificationShareDoc.vue?vue&type=template&id=76c1691a"
import script from "./NotificationShareDoc.vue?vue&type=script&lang=js"
export * from "./NotificationShareDoc.vue?vue&type=script&lang=js"
import style0 from "./NotificationShareDoc.vue?vue&type=style&index=0&id=76c1691a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports